var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("InvestmentReport.Menu.Finances")) + "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.hasProcuration && _vm.finances
      ? _c("div", [
          _vm.isPremises
            ? _c(
                "div",
                [
                  _c("premises-finances-view", {
                    attrs: {
                      model: _vm.finances.premises,
                      reportType: _vm.reportType
                    }
                  })
                ],
                1
              )
            : _vm.isICT
            ? _c(
                "div",
                [
                  _c("ict-finances-view", {
                    attrs: {
                      model: _vm.finances.ict,
                      reportType: _vm.reportType
                    }
                  })
                ],
                1
              )
            : _vm.isSupportApartments
            ? _c(
                "div",
                [
                  _c("support-apartments-finances-view", {
                    attrs: {
                      model: _vm.finances.supportApartments,
                      reportType: _vm.reportType
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("InvestmentReport.ProcurationOnly")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }